import React, { Component } from 'react'
import { MuiGrid, MuiTypography, MuiInputBase, MuiTextField, MuiButton, MuiToolTip } from '../../../../../ui/MaterialUIComponents'
import { Typography } from '@material-ui/core'
import lodashUtil from 'lodash';
import * as StringReplacer from '../../../../../../i18n/StringReplacer'
import { DialogComponentUtil } from '..';
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";
class TeacherAndTAsComponent extends Component {
	constructor(props) {
		super(props)
	}
	componentWillMount() {
		this.props.getNumberOfTeachersAndTAs();
	}
	render() {
		const { i18n } = this.props
		return (
			<React.Fragment>
				<MuiGrid container>
					<MuiToolTip
						placement="top-start"
						title={StringReplacer.getFormatedMessage(i18n.teachersAndTAs.heading,
							{
								Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
								Grades: DialogComponentUtil.getToolTipString(this.props),
							})
						} >
						<MuiTypography style={theme.typography.h6} gutterBottom>
							{StringReplacer.getFormatedMessage(i18n.teachersAndTAs.heading,
								{
									Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
									Grades: DialogComponentUtil.getGradeForTemplate(this.props),
								})
							}
						</MuiTypography>
					</MuiToolTip>
				</MuiGrid>


				{/* Box 1 */}
				<MuiGrid item xs container style={{ marginRight: "5px" }}>
					<MuiGrid
						container
						justify="center"
						alignItems="center"
						style={theme.tableHeaderStyle}
					>
						<MuiTypography style={theme.tableHeaderTextStyle}>
							{i18n.teachersAndTAs.numberOfTeachers}
						</MuiTypography>
					</MuiGrid>
					<MuiGrid container justify="center" style={theme.gridTableSelectStyle}>
						<MuiTextField
							style={{ width: "80%" }}
							// type="number" 
							//variant="standard"
							select
							autoComplete
							value={this.props.numberOfTeachersAndTAsForSubject.teachers}
							onChange={(event) => { this.props.handleChange(event.target.value, "teachers") }}
							SelectProps={{ native: true, disableUnderline: 'true' }}

						>
							<option style={{ display: 'none' }}>
							</option>
							{lodashUtil.times(this.props.totalTeachersForSubject + 1).map((i) => <option
								value={i}>{i}</option>)}
						</MuiTextField>
					</MuiGrid>
				</MuiGrid>

				{/* Box 2  */}
				<MuiGrid item xs container style={{ marginLeft: "5px" }}>
					<MuiGrid
						container
						justify="center"
						alignItems="center"
						style={theme.tableHeaderStyle}
					>
						<MuiTypography style={theme.tableHeaderTextStyle}>
							{i18n.teachersAndTAs.numberOfTAs}
						</MuiTypography>
					</MuiGrid>
					<MuiGrid container justify="center" style={theme.gridTableSelectStyle}>
						<MuiTextField
							style={{ width: "80%" }}
							// type="number" 
							//variant="standard"
							select
							autoComplete
							value={this.props.numberOfTeachersAndTAsForSubject.TAs}
							onChange={(event) => { this.props.handleChange(event.target.value, "TAs") }}
							SelectProps={{ native: true, disableUnderline: 'true' }}

						>
							<option style={{ display: 'none' }}>
							</option>
							{lodashUtil.times(this.props.totalTAsForSubject + 1).map((i) => <option
								value={i}>{i}</option>)}
						</MuiTextField>

					</MuiGrid>
				</MuiGrid>

				{/* buttons  */}
				<MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

					<MuiGrid item style={{ marginRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={() => { this.props.handleCloseForDialog() }}>
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>

					<MuiGrid item>
						{this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => { this.props.onClickOfSave() }}>
								{i18n.commonTexts.apply}
							</MuiButton>}
					</MuiGrid>
				</MuiGrid>
			</React.Fragment>
		)
	}
}

export default TeacherAndTAsComponent
